import { Component, forwardRef, Host, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DropdownModel } from 'src/app/models/master/dropdown-model';
import { MasterService } from 'src/app/services/master.service';
import { DropdownFormControl } from 'src/app/shared/inputs/dropdown-form-control';
import { inputMgsErrs } from 'src/app/validators/message-validation';

@Component({
  selector: 'app-input-dp-subdistrict',
  templateUrl: './input-dp-subdistrict.component.html',
  styleUrls: ['./input-dp-subdistrict.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDpSubdistrictComponent),
      multi: true
    },
  ]
})
export class InputDpSubdistrictComponent extends DropdownFormControl implements OnInit {
  errors = inputMgsErrs.subDistrict;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private translate: TranslateService,
    private masterService: MasterService
  ) { super(cc); }

  ngOnInit() {
    this.checkInitialControl();
    this.resetDropdownList();
  }

  initDropdownList(districtId?: string): Promise<any> {
    return new Promise<any>(resolve => {
      this.resetDropdownList();
      this.masterService.getSubDistricts(districtId).subscribe(result => {
        this.items.push(...result);
        this.findValueFromList(this.value);
        this.setAfterLoadItemDropdown();
        resolve('success');
      }, error => {
        resolve('error');
      });
    });
  }

  resetDropdownList() {
    this.items = new Array<DropdownModel>();
    // this.translate.get('input.dropdown.select.subdistrict').subscribe(label => {
    //   this.items.push({ value: null, label: label, data: null });
    // });
  }

  public getDropdownArray(): Array<DropdownModel> {
    return this.items ? this.items : [];
  }
}
